import { AuthState } from '../../types';
import * as types from './types';

export const setAuth = (values: AuthState) => {
  return {
    type: types.SET_AUTH,
    payload: values,
  };
};

export const clearAuthAndLogout = () => {
  return {
    type: types.CLEAR_AUTH,
  };
};
